export const GET_USERS = "GET_USERS";
export const USER_ERROR = "USER_ERROR";
export const CLEAR_USERS = "CLEAR_USERS";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const SET_CURRENT = "SET_CURRENT";
export const CLEAR_CURRENT = "CLEAR_CURRENT";
